import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';
import { FDDialogTitle } from '@facet-wealth/design';

const ChallengeTOTPStepMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('remainingAttempts', { hidden: true })
  .nameOverride('title', {
    _component: () => FDDialogTitle,
  }, overrideReadOnly)
  .nameOverride('primaryText', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly);

export default ChallengeTOTPStepMetaOverrideSet;
